import { Link } from "react-router-dom";
import styled from "@emotion/styled";
import {
  GHOST_BACKGROUND,
  GHOST_BACKGROUND_PRESSED,
  TERTIARY_GREY,
  HEADING,
  BACKGROUND_LIGHT,
  SECONDARY_GREY,
  DISABLED_COLOR,
} from "src/constants/colors";
import { BOX_SHADOW } from "src/constants/styles";

export const Container = styled.div<{
  isActive: boolean;
  isDrawerCollapsed: boolean;
}>`
  background-color: transparent;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  padding: ${({ isActive }) => (isActive ? "8px" : "0")};
  margin: 0px 8px 20px 8px;
  position: relative;
  height: ${({ isActive }) => (isActive ? "56px" : "auto")};
  overflow: hidden;
  transition:
    background-color 160ms ease-in-out,
    height 160ms ease-in-out,
    width 160ms ease-in-out;
  z-index: 10;

  ${({ isDrawerCollapsed }) =>
    isDrawerCollapsed &&
    `
    justify-content: center;
    align-items: center;
  `}

  &.active {
    background-color: ${BACKGROUND_LIGHT};
    border: 1px solid ${SECONDARY_GREY};
    border-radius: 24px 12px 12px 12px;
    box-shadow: ${BOX_SHADOW};
    height: 136px;
    width: 276px;
    position: fixed;
    left: 24px;
    bottom: 24px;
    z-index: 1000;
  }

  &:hover:not(.active) {
    background-color: ${SECONDARY_GREY};
  }
`;

export const Header = styled.div<{ isDrawerCollapsed: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: ${({ isDrawerCollapsed }) => (isDrawerCollapsed ? "0" : "8px")};
`;

export const MonogrammedDetailContainer = styled.div<{
  isDrawerCollapsed: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: ${({ isDrawerCollapsed }) => (isDrawerCollapsed ? "0" : "8px")};
  width: 100%;
  justify-content: ${({ isDrawerCollapsed }) =>
    isDrawerCollapsed ? "center" : "flex-start"};
`;

export const DetailContainer = styled.div<{ isActive: boolean }>`
  color: ${TERTIARY_GREY};
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 8px;
  width: ${(props) => (props.isActive ? 182 : 134)}px;
`;
export const NameLabel = styled.div`
  font-size: 14px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
export const EmailLabel = styled.div`
  font-size: 11px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: normal;
`;
export const ActionItem = styled.button`
  background-color: transparent;
  border: 0;
  cursor: pointer;
`;
export const Divider = styled.div`
  height: 1px;
  width: 100%;
  border-bottom: 1px solid ${SECONDARY_GREY};
  margin: 15px 0px 8px 0px;
`;
export const Row = styled(Link)<{ disabled?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 8px;
  text-decoration: none;
  border-radius: 6px;
  color: ${(props) => (props.disabled ? TERTIARY_GREY : "inherit")};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  width: 260px;
  ${(props) =>
    !props.disabled &&
    `
    &:hover {
      background-color: ${GHOST_BACKGROUND};
    }
    &:active {
      background-color: ${GHOST_BACKGROUND_PRESSED};
    }
      `}
`;
export const RowIcon = styled.div<{ disabled?: boolean }>`
  color: ${(props) => (props.disabled ? DISABLED_COLOR : TERTIARY_GREY)};
  height: 18px;
  width: 18px;
`;
export const RowLabel = styled.div<{ disabled?: boolean }>`
  color: ${(props) => (props.disabled ? DISABLED_COLOR : HEADING)};
  font-size: 14px;
`;
